/**
 * @see DesignGlobalIntent.conditionProperties.props.nodeTypeName.
 * @see DesignGlobalIntent.moduleProperties.props.nodeTypeName.
 * @see DesignModule.props.nodeTypeName.
 * @see DesignModuleLink.props.nodeTypeName.
 * @see DesignModuleNode.props.nodeTypeName.
 * @see DesignObject.props.nodeTypeName.
 * @see DesignIntent.props.nodeTypeName.
 */
export enum NodeTypeName {
  banner = 'Banner Message',
  base = 'Blank Object',
  begin = 'Module Begin',
  condition = 'Condition',
  custom = 'Custom Script',
  data = 'Data Access',
  dataAccessCompletion = 'Data Access Completion',
  dtmfMenu = 'Dtmf Menu',
  exit = 'Module Exit',
  flushPrompts = 'Flush Prompts',
  humanAssistedResolution = 'Human Assisted Resolution',
  input = 'Input',
  intent = 'Intent',
  intentCategory = 'Intent (Category)',
  link = 'Transition',
  loopEscalation = 'Loop Escalation',
  module = 'Module',
  moduleReference = 'Module Reference',
  note = 'Note',
  oasys = 'OASYS',
  playSavedPrompt = 'Play Saved Prompt',
  prompt = 'Prompt',
  promptReference = 'Prompt Reference',
  report = 'Reporting',
  richText = 'Rich Text',
  savePrompt = 'Save Prompt',
  session = 'Start Simultaneous Session',
  sessionCompletion = 'Simultaneous Session Completion',
  tab = 'Tabular Router',
  trustedResponse = 'Trusted Response',
  variable = 'Variable Definition',
  withFiller = 'With Filler'
}
